module.exports = __webpack_public_path__ + "590029e9f5d02e0c8f7f67d25af7e391.MP3";